import Vue from 'vue';
import EventService from '../services/EventService.js';

export default {
  namespaced: true,

  state: {
    isLoading: false,
    error: null,
    months: [],
    total: 0,
    events: [],
  },

  getters: {
    getTotal(state) {
      return state.total;
    },

    getMonths(state) {
      return state.months;
    },

    getEvents(state) {
      return state.events;
    },

    hasMonthEventsInRegion: state => {
      return (month, region) => {
        return 0 < state.events[month][region].length;
      }
    },

    hasMonthEvents: state => {
      return month => {
        if (!state.events[month]) {
          return false;
        }

        let i = 0;

        for (; i < state.events[month].length; i++) {
          if (0 < state.events[month][i].length) {
            return true;
          }
        }

        return false;
      }
    },

    getRegionsByMonth: state => {
      return month => {
        return state.events[month];
      }
    },
  },

  mutations: {
    ['FETCH_EVENTS'](state) {
      state.isLoading = true;
      state.error = null;
      state.events = [];
    },

    ['FETCH_EVENTS_SUCCESS'](state, data) {
      state.isLoading = false;
      state.total = data.total;
      state.events = data.rows;
    },

    ['UPDATE_EVENT_MONTHS'](state) {
      let currentMonth = parseInt(Vue.moment().format("M")),
          endMonth     = currentMonth + 12,
          months       = [],
          i            = currentMonth;

      for (; i < endMonth; i++) {
        let month = i;

        if (month > 12) {
          month = month % 12;
        }

        months.push(month);
      }

      state.months = months;
    }
  },

  actions: {
    fetchEvents({ commit }) {
      commit('FETCH_EVENTS');

      return EventService.getEvents().then(
        res => {
          commit('FETCH_EVENTS_SUCCESS', res.data);
          commit('UPDATE_EVENT_MONTHS');
        }
      );
    },
  }
}
